import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { richTextEditorStrings } from '../../../i18n/components/richtTextEditor';
import { TextTemplate } from '../textTemplates';
import { INSERT_TEMPLATE_COMMAND } from './TemplatePlugin';

export interface TemplatePickerPluginProps {
  templates: TextTemplate[];
  values?: Record<string, string>;
}

export function TemplatePickerPlugin({
  templates,
  values,
}: TemplatePickerPluginProps) {
  const [editor] = useLexicalComposerContext();

  const insert = (event: DropdownChangeEvent) => {
    const template = event.value as TextTemplate | null;
    if (!template) {
      return;
    }
    editor.focus(() =>
      editor.dispatchCommand(INSERT_TEMPLATE_COMMAND, {
        content: template.content,
        values,
      }),
    );
  };

  return (
    <span className="lexical-toolbar-group">
      <Dropdown
        value={null}
        options={templates}
        optionLabel="name"
        onChange={insert}
        filter
        placeholder={richTextEditorStrings.templates.placeholder}
        aria-label={richTextEditorStrings.templates.label}
        emptyMessage={richTextEditorStrings.templates.empty}
        className="lexical-template-picker"
      />
    </span>
  );
}
